import React from 'react';
import { whyChooseUs } from '../data/mockData';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 bg-white" data-testid="why-choose-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">Why Choose Us</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            The Trademark Team Businesses Trust
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-px bg-zinc-200 rounded-lg overflow-hidden mb-12">
          {whyChooseUs.map((usp) => {
            const IconComponent = Icons[usp.icon];
            return (
              <div key={usp.id} className="bento-hover bg-white p-10" data-testid={`why-choose-card-${usp.id}`}>
                <div className="w-12 h-12 bg-[#002FA7] rounded-md flex items-center justify-center mb-5">
                  {IconComponent && <IconComponent className="w-6 h-6 text-white" />}
                </div>
                <h3 className="text-base font-bold text-[#09090B] mb-3" style={{fontFamily:'Outfit,sans-serif'}}>{usp.title}</h3>
                <p className="text-sm text-zinc-500 leading-relaxed">{usp.description}</p>
              </div>
            );
          })}
        </div>
        <div className="text-center">
          <Button onClick={onOpenContactForm} className="btn-lift bg-[#002FA7] hover:bg-[#001D66] text-white px-8 py-5 font-semibold rounded-md" data-testid="why-choose-cta">
            Start Your Registration <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
